import { bindedModelBase } from "../Models/BindedModel.js";
export var StateTypes;
(function (StateTypes) {
    StateTypes[StateTypes["loading"] = 0] = "loading";
    StateTypes[StateTypes["new"] = 1] = "new";
    StateTypes[StateTypes["calibrated"] = 2] = "calibrated";
    StateTypes[StateTypes["deformityAnalysis"] = 3] = "deformityAnalysis";
    StateTypes[StateTypes["EOC"] = 4] = "EOC";
    StateTypes[StateTypes["templating"] = 5] = "templating";
    StateTypes[StateTypes["RPM"] = 6] = "RPM";
    StateTypes[StateTypes["tlhex"] = 7] = "tlhex";
    StateTypes[StateTypes["tlhexSchedule"] = 8] = "tlhexSchedule";
})(StateTypes || (StateTypes = {}));
export var SelectedApexMech;
(function (SelectedApexMech) {
    SelectedApexMech[SelectedApexMech["none"] = 0] = "none";
    SelectedApexMech[SelectedApexMech["femurProximal"] = 1] = "femurProximal";
    SelectedApexMech[SelectedApexMech["femurDistal"] = 2] = "femurDistal";
    SelectedApexMech[SelectedApexMech["tibiaProximal"] = 3] = "tibiaProximal";
    SelectedApexMech[SelectedApexMech["tibiaDistal"] = 4] = "tibiaDistal";
})(SelectedApexMech || (SelectedApexMech = {}));
export var SelectedApexAnat;
(function (SelectedApexAnat) {
    SelectedApexAnat[SelectedApexAnat["none"] = 0] = "none";
    SelectedApexAnat[SelectedApexAnat["proximal"] = 1] = "proximal";
    SelectedApexAnat[SelectedApexAnat["distal"] = 2] = "distal";
})(SelectedApexAnat || (SelectedApexAnat = {}));
export var FlipType;
(function (FlipType) {
    FlipType[FlipType["horizontal"] = 0] = "horizontal";
    FlipType[FlipType["vertical"] = 1] = "vertical";
})(FlipType || (FlipType = {}));
export var FlipTypeGarage;
(function (FlipTypeGarage) {
    FlipTypeGarage[FlipTypeGarage["horizontal"] = 0] = "horizontal";
    FlipTypeGarage[FlipTypeGarage["vertical"] = 1] = "vertical";
    FlipTypeGarage[FlipTypeGarage["both"] = 2] = "both";
})(FlipTypeGarage || (FlipTypeGarage = {}));
/**
 * Abstract class to create a state.
 */
export class State {
    /**
    * Function called after the state is initialized and assigned to the context.
    */
    onAfterInit() {
        bindedModelBase.appState = this.type;
        this.initState();
    }
    constructor(context, caseModel, stateType, restore) {
        this._context = context;
        this._caseModel = caseModel;
        this._restore = restore;
        this.type = stateType;
        if (restore) {
            for (const key in restore) {
                this[key] = restore[key]; // TODO fix d.ts
            }
        }
    }
    /**
     * Triggers an event.
     */
    handle(event, args) {
        const newState = this.handleChangeStateEvent(event, args);
        return newState === undefined ? this.handleNotChangeStateEvent(event, args) :
            (newState.type > -1 ? newState : { type: this.type });
    }
    /**
     * If handleChangeStateEvent function returns undefined, this will be called. Triggers events available for all states.
     */
    handleNotChangeStateEvent(event, args) {
        switch (event) {
            case "setView":
            case "setViewMultiple":
            case "zoomIn":
            case "zoomOut":
            case "fitToView":
            case "setVisibility":
            case "setBrightness":
            case "setContrast":
            case "addLine":
            case "addGoniometer":
            case "onBridgeResult":
            case "resetLabelsPosition":
            case "deleteMeasurementTool":
            case "setFlip":
            case "setFlipGarage":
            case "startTrackingPlane":
            case "detectChangesPlane":
                return this.dispatchToMain(event, args);
            case "undo":
            case "redo":
                this.dispatchToMain(event, args);
                return this.dispatchToMain('onBridgeResult', 'historyChanged');
        }
        console.error("add", event, "to handleNotChangeStateEvent");
        return { type: this.type };
    }
    dispatchToMain(type, args) {
        this._context.dispatchEvent({ type: type, args }); // TODO fix d.ts
        return { type: this.type }; // TODO check only return this instead
    }
}
//# sourceMappingURL=State.js.map